import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';
import { PermissionsService } from './shared/services/permissions.service';
import { switchMap, map, catchError, of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {

  constructor(private auth: AuthService, private permissions: PermissionsService) { }

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ) {

    const returnUrl = window.location.href;

    return this.auth.checkSession().pipe(
      switchMap((isAuth: boolean) => {
        if (!isAuth) {
          this.auth.login(returnUrl);
          return of(false);
        }

        return this.permissions.loadPermissions().pipe(
          map(() => true),
          catchError(() => of(true))
        );
      }),
      catchError((err: HttpErrorResponse) => {
        this.auth.login(returnUrl);
        return of(false);
      })
    );
  }
}
